<template>
  <Page>
    <NavBar title="操作说明" />
    <main class="operation-guide">
      <header class="guide-header">
        <h1 class="text-20 font-500 text-main">电子税务局APP操作指引</h1>
      </header>

      <section v-for="(step, index) in steps" :key="step.title" class="guide-section">
        <div class="guide-section-title">
          <span class="step-index text-14 font-500 text-white">{{ index + 1 }}</span>
          <h2 class="text-16 font-500 text-main">{{ step.title }}</h2>
        </div>

        <div v-for="(guideItem, itemIndex) in step.items" :key="itemIndex" class="guide-item">
          <p v-if="guideItem.description" class="guide-text text-14 leading-20 text-main">
            {{ guideItem.description }}
          </p>
          <img
            v-if="guideItem.image"
            class="guide-image"
            :src="guideItem.image.src"
            :alt="guideItem.image.alt"
            loading="lazy"
          />
        </div>
      </section>
    </main>
  </Page>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import NavBar from '@/components/NavBar/index.vue';
import appSearchImage from '@/assets/operation-guide/01-app-search.png';
import selectHubeiImage from '@/assets/operation-guide/02-select-hubei.png';
import myLoginImage from '@/assets/operation-guide/03-my-login.png';
import registerImage from '@/assets/operation-guide/04-register.png';
import agreementImage from '@/assets/operation-guide/05-agreement.png';
import identityImage from '@/assets/operation-guide/06-identity.png';
import phoneVerifyImage from '@/assets/operation-guide/07-phone-verify.png';
import passwordImage from '@/assets/operation-guide/08-password.png';
import registerSuccessImage from '@/assets/operation-guide/09-register-success.png';
import realNameLevelImage from '@/assets/operation-guide/10-real-name-level.png';

const image = (src, alt) => ({ src, alt });
const item = (description, guideImage) => ({ description, image: guideImage });

const steps = [
  {
    title: '下载安装“电子税务局”APP',
    items: [item('手机应用商店搜索“电子税务局”下载安装', image(appSearchImage, '手机应用商店搜索电子税务局'))]
  },
  {
    title: '选择省份城市',
    items: [item('下载完成后，打开页面选择“湖北”', image(selectHubeiImage, '电子税务局APP选择湖北'))]
  },
  {
    title: '点击“我的”>“立即登录”',
    items: [item('', image(myLoginImage, '电子税务局APP我的页面和立即登录入口'))]
  },
  {
    title: '新用户点击“用户注册”，已注册的用户可以直接登录',
    items: [
      item('1、点击“用户注册”', image(registerImage, '电子税务局APP用户注册入口')),
      item('2、勾选“协议”，点击“下一步”', image(agreementImage, '电子税务局APP勾选协议并下一步')),
      item('3、输入本人身份信息，点击“下一步”。', image(identityImage, '电子税务局APP输入身份信息')),
      item('3、选择“实名手机号验证”，然后点击“下一步”', image(phoneVerifyImage, '电子税务局APP选择实名手机号验证')),
      item('4、设置密码，点击“下一步”', image(passwordImage, '电子税务局APP设置登录密码')),
      item('5、注册成功，点击“去登录”', image(registerSuccessImage, '电子税务局APP注册成功并去登录'))
    ]
  },
  {
    title: '查看实名等级是否满足“三级”',
    items: [
      item(
        '1、点击“我的”查看实名等级是否为“三级”或三级以上，满足“三级”或三级以上即操作完成',
        image(realNameLevelImage, '电子税务局APP查看实名等级')
      )
    ]
  }
];

export default defineComponent({
  name: 'WaybillOperationGuide',
  components: { NavBar },
  setup() {
    return { steps };
  }
});
</script>

<style lang="less" scoped>
.operation-guide {
  min-height: 100%;
  padding: 0.16rem 0.12rem 0.32rem;
  background: #f5f6f9;
}

.guide-header {
  padding: 0.04rem 0.12rem 0.16rem;
}

.guide-section {
  padding: 0.16rem 0.12rem;
  margin-bottom: 0.12rem;
  background: #fff;
  border-radius: 0.04rem;
}

.guide-section:last-child {
  margin-bottom: 0;
}

.guide-section-title {
  display: flex;
  align-items: center;
  min-height: 0.24rem;
}

.step-index {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.08rem;
  background: #0076ff;
  border-radius: 50%;
}

.guide-item {
  margin-top: 0.12rem;
}

.guide-text {
  margin: 0;
}

.guide-image {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 0.08rem;
  background: #f5f6f9;
  border: 1px solid #eeeeee;
  border-radius: 0.04rem;
}

.guide-item > .guide-image:first-child {
  margin-top: 0;
}
</style>
